<template>
	<div class="page">
		
		<div class="content" >
			<el-form class="searchBox">
				<el-row>
					<el-col :span="4">
						<el-form-item>
							<el-input style="width:130px;margin-right: 10px;" placeholder="请输入关键字" v-model="search3.keyword" clearable @keyup.enter.native="changeSearch3" size="small"></el-input>
							<el-button @click="changeSearch3" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="状态" :label-width="'60px'">
							<el-select style="width:100px;" class="select" v-model="search3.state" @change="changeSearch3" placeholder="请选择" size="small">
								<el-option v-for="item in [{label:'未验收',value:'1'},{label:'部分验收',value:'2'},{label:'已验收',value:'3'},{label:'取消',value:'-2'}]" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="发货日期" :label-width="'90px'">
							<el-date-picker @change="changeSearch3" v-model="datetimerange3" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" style="width: 220px;">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4" style="text-align: right;">
						<resetBtn @reset="reset3" style="width:56px;display: inline-block;margin:0px 10px;"></resetBtn>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData3" style="width: 100%">
				<el-table-column prop="no" label="发货单号" >
					<template slot-scope="scope">
						{{scope.row.purchaseNo}}
					</template>
				</el-table-column>
				<el-table-column label="发货时间" >
					<template slot-scope="scope">
						{{scope.row.createOperationInfo.operationTime}}
					</template>
				</el-table-column>
				<el-table-column label="采购人" >
					<template slot-scope="scope">
						{{scope.row.createOperationInfo.userName}}
					</template>
				</el-table-column>
				<el-table-column label="发往门店" >
					<template slot-scope="scope">
						<span>{{scope.row.shopInfo.shopName}}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" >
					<template slot-scope="scope">
						{{scope.row.state.name}}
					</template>
				</el-table-column>
				<el-table-column label="验收日期" >
					<template slot-scope="scope">
						{{scope.row.updateOperationInfo&&scope.row.updateOperationInfo.operationTime}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
					<template slot-scope="scope">
						<el-button v-if="scope.row.state.id==='3'" @click="$router.push({path:'/wuliao/checkSee',query:{id:scope.row.id}})" type="text" size="small">查看</el-button>
						<el-button v-else @click="$router.push({path:'/wuliao/checkSee',query:{id:scope.row.id}})" type="text" size="small">验收</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page :total="page3.total" :page="page3.page" @change="changePage3" style="padding-bottom: 10px;"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	import resetBtn from "../../../components/resetBtn.vue"
	export default {
		components: { page, resetBtn},
		data() {
			return {
				activeIndex:'1',
				// 资产申请单
				search1:{
					"keyword": "",
					"userid": "", // 用户id
					"starttime": "",
					"endtime": "",
					"state": '', // 状态 -4：退款成功 -3：退款中 -2已取消 -1 全部  0：已删除  1：已创建  2：支付中 3 支付成功 4：已接单   5： 已发货    8：已完成
					"pay_type": '', // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
				},
				datetimerange1:[],
				page1:{
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData1:[],
				// 资产管理
				search2:{
					"keyword": "",
					"userid": "", // 用户id
					"starttime": "",
					"endtime": "",
					"state": '', // 状态 -4：退款成功 -3：退款中 -2已取消 -1 全部  0：已删除  1：已创建  2：支付中 3 支付成功 4：已接单   5： 已发货    8：已完成
					"pay_type": '', // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
				},
				datetimerange2:[],
				page2:{
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData2:[],
				// 资产发货单
				search3:{
					"keyword": "",
					"state": '', // 1 未验收 2部分验收 3 已验收 -2 取消
				},
				datetimerange3:[],
				page3:{
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData3:[],
			}
		},
		computed: {
			curShopId() {
				return this.$store.state.shopId;
			},
		},
		mounted() {
			this.getTableData3();
		},
		methods: {
			// 资产发货单
			reset3() {
				this.search3.keyword = '';
				this.search3.state = '';
				this.search3.datetimerange3 = [];
				this.page3.page = 1;
				this.getTableData3();
			},
			changeSearch3() {
				this.page3.page = 1;
				this.getTableData3()
			},
			changePage3(num) {
				this.page3.page = num;
				this.getTableData3();
			},
			getTableData3() {
				let loading = this.$loading();
				let params = {
					"keyWord": this.search3.keyword,
					"shopId": this.curShopId,
					"state": this.search3.state,
					"assetsCode": "",
					"assetsType": "",
					beginTime:'',
					endTime:'',
					"pageIndex": this.page3.page,
					"pageSize": this.page3.pageSize,
				}
				if (this.datetimerange3 && this.datetimerange3.length == 2) {
					params.beginTime = new Date(this.datetimerange3[0])
					params.endTime = new Date(this.datetimerange3[1])
				}
				this.$http.post(process.env.VUE_APP_zichan+'/api/AssetsPurchase/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData3 = res.data.list;
						this.page3.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
	.page {
		.searchView {
			
			.tabLine{
				display: flex;
				.tabItem {
					width:88px;
					box-sizing: border-box;
					line-height: 36px;
					text-align: center;
					border-right: 1px solid #F2F2F2;
					cursor: pointer;
					font-size: 14px;
					background-color: #fff;
					&.active {
						color: $mainColor;
					}
				}
			}
			.searchBox{
				border-top:1px solid #F2F2F2;
			}
		}

		.content {
			padding: 0 0px;
			min-height: 600px;
			::v-deep .el-form-item {
				margin-bottom: 0;
				.el-form-item__label{
					padding-right: 5px;
					font-size: 12px;
				}
			}
		}
	}
</style>
